module.exports = __webpack_public_path__ + "static/media/modamilyText@2x.2ec29123.png";